/**
 * The firm's clock (`LawFirm.timezone`, an IANA name). Casey's "today" and
 * the deadlines its tools report use it; it is seeded from the first admin's
 * browser and editable in Settings > General.
 */

/** The browser's IANA timezone, or null when the runtime can't say. */
export const browserTimezone = (): string | null => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch {
    return null;
  }
};

const COMMON = [
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Phoenix",
  "America/Los_Angeles",
  "America/Anchorage",
  "Pacific/Honolulu",
  "America/Puerto_Rico",
  "Europe/London",
  "UTC"
];

/** Every timezone the runtime knows (common US zones first), plus `current`. */
export const timezoneOptions = (current?: string | null): string[] => {
  let all: string[] = [];
  try {
    const intl = Intl as unknown as {
      supportedValuesOf?: (key: string) => string[];
    };
    all = intl.supportedValuesOf?.("timeZone") ?? [];
  } catch {
    all = [];
  }
  const rest = all.filter((z) => !COMMON.includes(z));
  const options = [...COMMON, ...rest];
  return current && !options.includes(current)
    ? [current, ...options]
    : options;
};

/** "America/New_York" → "New York (America)". */
export const timezoneLabel = (zone: string): string => {
  const parts = zone.split("/");
  if (parts.length < 2) return zone;
  const city = parts[parts.length - 1].replace(/_/g, " ");
  return `${city} (${parts[0]})`;
};
